<template>
  <div class="flex flex-row mb-5">
    <div>
      <router-link :to="{name:'home'}">
        SoccerPresso <i class="fas fa-arrow-right mr-2" />
      </router-link>
    </div>
    <div v-if="routes">
      <div
        v-for="route in routes"
        :key="route.display"
      >
        <router-link :to="route.route">
          {{ route.display }} <i
            v-if="route && !route.isLast"
            class="fas fa-arrow-right mr-2"
          />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Breadcrumb',
    data () {
        return {
            routes: []
        }
    },
    watch: {
        $route (to, from) {
            this.buildRoute()
        }
    },
    mounted () {
        this.buildRoute()
    },
    methods: {
        buildRoute () {
            const result = []
            this.$router.currentRoute.matched.forEach(function (element) {
                if (element.meta && element.meta.display) {
                    result.push({
                        name: element.name,
                        display: element.meta.display,
                        route: element,
                        isLast: false
                    })
                }
            })

            if (result[result.length - 1]) {
                result[result.length - 1].isLast = true
            }
            this.routes = result
        }
    }
}
</script>

<style scoped>

</style>